import React from 'react'
import PageHeader from '../components/shared/pageHeader/PageHeader'
import LeadsCreateHeader from '../components/leads/FormReaderHeader'
import LeadsCreateContent from '../components/leads/FormReaderTable'
import Footer from '../components/shared/Footer'

const CategoryTable = () => {
    return (
        <>
            <PageHeader>
                <LeadsCreateHeader />
            </PageHeader>

            <div className='main-content'>
                <div className='row'>
                    <LeadsCreateContent/>
                </div>
            </div>
            
        </>
    )
}

export default CategoryTable